// extracted by mini-css-extract-plugin
module.exports = {"event-card":"EventCard_event-card__vqeTZ","event-card__title":"EventCard_event-card__title__RgU1t"};